import { Button } from 'antd'
import React from 'react'

import { AvatarRow } from 'shared/atoms/AvatarRow'

export interface CollaboratorSummaryProps {
  button?: any
  count?: number
  style?: React.CSSProperties
  users: { name: string; avatar?: string }[]
}

export const CollaboratorSummary: React.FC<CollaboratorSummaryProps> = (props) => {
  const { users = [], count = users.length, style, button: ButtonProp } = props

  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'center',
        ...style,
      }}
    >
      <strong
        style={{
          marginRight: '.5rem',
        }}
      >
        {count} collaborator{count === 1 ? '' : 's'}
      </strong>
      {!!users.length && <AvatarRow users={users.slice(0, 3)} />}
      <span
        style={{
          marginLeft: '.5rem',
        }}
      >
        {ButtonProp ? ButtonProp : <Button>Invite</Button>}
      </span>
    </div>
  )
}
